import React, { useEffect, useState } from "react"
import Footer from "./footer/Footer"
import Header from "./header/Header"
import Main from "./main/Main"
import { RGPDCookieBanner } from "gatsby-plugin-rgpd-acceptance"
import Breadcrumb from "./breadcrumb/Breadcrumb"

const Layout = ({
  siteData,
  jobAdsData,
  sectorsData,
  productCategoriesTree,
  gcProductCategoriesTree,
  children,
  pageContext,
}) => {
  useEffect(() => {
    const elementsToLoadIn = Array.from(document.querySelectorAll(".loadin"))
    const observerOptions = {
      root: null,
      rootMargin: "0% 0% -10% 0%",
      threshold: 0.1,
    }
    function observerCallback(entries) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("loaded")
        } else {
          entry.target.classList.remove("loaded")
        }
      })
    }
    const observer = new IntersectionObserver(observerCallback, observerOptions)
    elementsToLoadIn.forEach((el) => observer.observe(el))
  }, [])
  const [forceCookiesSettings, setForceCookiesSettings] = useState(false)
  return (
    <>
      <Header
        siteData={siteData}
        sectorsData={sectorsData}
        jobAdsData={jobAdsData}
        productCategoriesTree={productCategoriesTree}
        gcProductCategoriesTree={gcProductCategoriesTree}
      />
      <Main>
        <div className="animation">{children}</div>
      <Breadcrumb breadcrumbs={pageContext.filAriane} />
      </Main>
      <Footer siteData={siteData} setForceCookiesSettings={setForceCookiesSettings} forceCookiesSettings={forceCookiesSettings} />
      <RGPDCookieBanner setForceCookiesSettings={setForceCookiesSettings} forceCookiesSettings={forceCookiesSettings} asAContainer={true}/>
    </>
  )
}

export default Layout
